import { render, staticRenderFns } from "./WebMenuItem.vue?vue&type=template&id=11fcd0d4&"
import script from "./WebMenuItem.vue?vue&type=script&lang=js&"
export * from "./WebMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports